define([
    "jquery",
    "underscore",
    "marionette",
    "videojs"
], function($, _, Marionette) {
    return Marionette.View.extend({
        el: '.video_wrap',

        initialize: function(){
        }
    });
});


//////////////////
// WEBPACK FOOTER
// ./assets/common/main/js/views/w/common/video_view.js
// module id = 22
// module chunks = 0